import { isPreparedDropUuidString } from './siem-resolve.util';

export type { DropTimelineContext, DropTimelinePickTarget } from './types';
export {
  extractDropTimelineContextFromSiem,
  extractFromDropAction,
  extractFromSiemDetailBodies,
  isPreparedDropUuidString,
  mergeCtx,
  parseDropId,
  parseTimelineUniqueId,
} from './siem-resolve.util';
export { extractDropTimelineContextFromAudit } from './audit-context.util';

const UID_RE = /^[A-Za-z0-9-]{4,64}$/;

export function isSiemDropRelatedAction(action: string | null): boolean {
  if (typeof action !== 'string') return false;
  if (action.includes('/smswiser/drops')) return true;
  return (
    action.includes('/smswiser/campaigns/') && action.includes('/prepared-drops')
  );
}

export function hasDropTimelineUniqueId(ctx: {
  uniqueId?: string;
}): boolean {
  return ctx.uniqueId != null && UID_RE.test(ctx.uniqueId);
}

export function hasDropTimelineFollowTarget(ctx: {
  uniqueId?: string;
  wiserDropId?: number;
  preparedDropId?: string;
  pickTargets?: { preparedDropId?: string; wiserDropId?: number; uniqueId?: string }[];
}): boolean {
  const picks = ctx.pickTargets?.length ?? 0;
  if (picks > 0) return true;
  const uidOk = ctx.uniqueId != null && UID_RE.test(ctx.uniqueId);
  const widOk =
    ctx.wiserDropId != null &&
    Number.isInteger(ctx.wiserDropId) &&
    ctx.wiserDropId >= 1;
  const prepOk =
    ctx.preparedDropId != null &&
    isPreparedDropUuidString(ctx.preparedDropId);
  return uidOk || widOk || prepOk;
}
